import * as CONSTANTS from "./Constants";
class Auth {
  public setAccessToken(token: any) {
    localStorage.setItem(CONSTANTS.ACCESS_TOKEN, token);
  }
  public setRefreshToken(token: any) {
    localStorage.setItem(CONSTANTS.REFRESH_TOKEN, token);
  }
  public setUserName(name: any) {
    localStorage.setItem(CONSTANTS.SET_USERNAME, name);
  }
  public removeTokens() {
    localStorage.removeItem(CONSTANTS.ACCESS_TOKEN);
    localStorage.removeItem(CONSTANTS.REFRESH_TOKEN);
    localStorage.removeItem(CONSTANTS.SET_USERNAME);
    localStorage.removeItem(CONSTANTS.HAS_LOGGED_OUT);
  }
  public getAccessToken() {
    return localStorage.getItem(CONSTANTS.ACCESS_TOKEN) || "";
  }
  public getRefreshToken() {
    return localStorage.getItem(CONSTANTS.REFRESH_TOKEN) || "";
  }
  public getUserName(): string {
    return localStorage.getItem(CONSTANTS.SET_USERNAME) || "";
  }
  public setRememberMe(username: string, password: string): void {
    const remberMe = JSON.stringify({
        username,
        password,
        RememberMe: true,
      })
    let encodedRememberMe = encodeURIComponent(remberMe.replace(/\+/g, " "))
    localStorage.setItem(CONSTANTS.SET_REMEMBER_ME, encodedRememberMe);
  }
  public removeRemeberMe(): void {
    localStorage.removeItem(CONSTANTS.SET_REMEMBER_ME);
  }
  public getRemberMe() {
    const getRemeber = localStorage.getItem(CONSTANTS.SET_REMEMBER_ME) || "";
    if (getRemeber) {
      let decodedGetRemember = decodeURIComponent(getRemeber.replace(/\+/g, " "))
      return JSON.parse((decodedGetRemember));
    } else {
      return getRemeber;
    }
  }

  public isLoggedIn(): boolean {
    let valid = false;
    if (this.getRefreshToken()) {
      const tokenParts = JSON.parse(atob(this.getRefreshToken().split(".")[1]));

      // exp date in token is expressed in seconds, while now() returns milliseconds:
      const now = Math.ceil(Date.now() / 1000);

      if (tokenParts.exp > now) {
        valid = true;
      } else {
        this.removeTokens();
      }
    }
    return valid;
  }

  public getUserId(): string {
    if (this.getRefreshToken()) {
      const tokenParts = JSON.parse(atob(this.getRefreshToken().split(".")[1]));
      return tokenParts?.sub
    }
  }

  public isAccessTokenExp(): boolean {
    let valid = false;
    if (this.getAccessToken() && this.getRefreshToken()) {
      const acsTokenParts = JSON.parse(
        atob(this.getAccessToken().split(".")[1])
      );
      const refTokenParts = JSON.parse(
        atob(this.getRefreshToken().split(".")[1])
      );

      // exp date in token is expressed in seconds, while now() returns milliseconds:
      const now = Math.ceil(Date.now() / 1000);

      if (refTokenParts.exp > now && acsTokenParts.exp < now) {
        valid = true;
      }
    }
    return valid;
  }

  public getPermissions(): any {
    if (this.getAccessToken()) {
      var decoded = JSON.parse(atob(this.getAccessToken().split(".")[1]));
      return decoded || null;
    }
  }
}

const auth = new Auth();
export default auth;
